import { getDefaultInstrumentType } from "../config/features";
import { ChainIdEnum } from "../enums/chain";
import { AssetResponse } from "./asset";

export const getDefaultTradingAsset = (): AssetResponse =>
  (process.env.REACT_APP_DEFAULT_TRADING_ASSET as AssetResponse | undefined) ||
  (process.env.REACT_APP_CHAIN_ID === String(ChainIdEnum.MONAD_TESTNET)
    ? "MON"
    : process.env.REACT_APP_CHAIN_ID === String(ChainIdEnum.ARC_TESTNET)
    ? "BTC"
    : "ETH");

/**
 * The market the app lands on. The vertical is whichever enabled trading type
 * sorts first (see src/config/features) rather than a hard-coded PERPETUAL, so
 * a build with perps switched off still opens on something tradable.
 */
export const getDefaultTradingMarket = () => ({
  asset: getDefaultTradingAsset(),
  derivative: getDefaultInstrumentType(),
});

export const getChainScopedStorageKey = (key: string): string => {
  const chainId = process.env.REACT_APP_CHAIN_ID || "default";
  return `${key}:${chainId}`;
};
